module.exports = "/_next/static/images/Hero-6a0eb9facda67c8436f4bf1e6ae3eb79.webp";